import { render, staticRenderFns } from "./ProfessionsList.vue?vue&type=template&id=ceac558a&scoped=true"
import script from "./ProfessionsList.vue?vue&type=script&lang=ts"
export * from "./ProfessionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceac558a",
  null
  
)

export default component.exports